<a
  rds-link
  standalone
  size="m"
  role="button"
  tabindex="0"
  class="back-nav"
  (click)="goBack()"
  (keydown.enter)="goBack()">
  <rds-icon namespace="filled" icon="arrow_left"></rds-icon>
  Back
</a>

<div class="details-header">
  <h2 class="details-title">
    <span>Bookly ID: #{{ bookingData.bookingId }}</span>
    @if (bookingDetails(); as bookingDetails) {
      <rds-badge
        size="m"
        type="minimal"
        [color]="bookingDetails.bookingDetails.status.color"
        [label]="bookingDetails.bookingDetails.status.text">
      </rds-badge>
    }
  </h2>
</div>

<div class="details-content">
  <rds-tabs ariaLabel="Booking request details tabs">
    <rds-tab label="Detail">
      <div class="details">
        @if (bookingDetails()) {
          <bad-event-details
            [startDate]="eventDateTime"
            [eventDetails]="bookingDetails()"
            [role]="role"
            (isEditModeEnabled)="setEditMode($event)"></bad-event-details>
        }
        @if (isLoading()) {
          <div class="loader">
            <rds-progress-spinner></rds-progress-spinner>
          </div>
        }
      </div>
    </rds-tab>
    <rds-tab
      #messagesTab
      label="Messages"
      [active]="bookingData.setActiveTab === NotificationSourceTypeEnum.Chat">
      <div class="details">
        @if (isMessageLoading()) {
          <div class="loader">
            <rds-progress-spinner></rds-progress-spinner>
          </div>
        }
        <bsh-messages
          [bookingRequestStatus]="
            bookingDetails()?.bookingDetails?.status?.value
          "
          [chatMessages]="chatMessages()"
          (sendMessage)="
            postMessage($event, ChatMessageTypeEnum.Chat)
          "></bsh-messages>
      </div>
    </rds-tab>
    <rds-tab label="Calendar">
      <div class="details">
        <bsh-room-bookings-calendar
          (dateSelected)="fillEventDate($event)"
          [roomBooking]="bookingDetails()"
          [stickyHeader]="true"></bsh-room-bookings-calendar>
      </div>
    </rds-tab>
    <rds-tab label="Work Notes">
      <div class="details">
        @if (isMessageLoading()) {
          <div class="loader">
            <rds-progress-spinner></rds-progress-spinner>
          </div>
        }
        <rds-alert class="mb-8">
          Work notes are visible only for room hosts and service providers. To
          contact with booking requester use Messages tab
        </rds-alert>
        <bsh-messages
          [bookingRequestStatus]="
            bookingDetails()?.bookingDetails?.status?.value
          "
          type="WORK_NOTE"
          [chatMessages]="workNotes()"
          (sendMessage)="
            postMessage($event, ChatMessageTypeEnum.WorkNote)
          "></bsh-messages>
      </div>
    </rds-tab>
    <rds-tab label="History">
      <div class="details">
        @if (isBookingHistoryLoading()) {
          <div class="loader">
            <rds-progress-spinner></rds-progress-spinner>
          </div>
        }
        <bad-booking-history [entries]="bookingHistory()" />
      </div>
    </rds-tab>
  </rds-tabs>
</div>

@if (bookingDetails(); as bookingDetails) {
  <div class="details-actions">
    <!--
      Edit / Save / Cancel are owned by bad-event-details but rendered here, so
      every action for the booking sits in one bar pinned to the bottom.
    -->
    @if (eventDetails(); as details) {
      @if (isEditMode()) {
        <button rds-secondary-button size="m" (click)="details.cancel()">
          Cancel
        </button>
        <button
          rds-primary-button
          *bshHasAccess="{
            role,
            permissions: [Permission.CAN_EDIT_ROOMBOOKINGS],
          }"
          size="m"
          [disabled]="!details.canSave"
          (click)="details.save()">
          Save
        </button>
      } @else if (details.isEditable && isDetailTabActive()) {
        <button
          rds-secondary-button
          *bshHasAccess="{
            role,
            permissions: [Permission.CAN_EDIT_ROOMBOOKINGS],
          }"
          size="m"
          (click)="details.switchToEditMode()">
          Edit
        </button>
      }
    }
    @if (
      bookingDetails.bookingDetails.status.value === BookingStatusEnum.Approved
    ) {
      <button
        rds-secondary-button
        *bshHasAccess="{
          role,
          permissions: [Permission.CAN_CANCEL_ROOMBOOKINGS],
        }"
        size="m"
        (click)="openModal(BookingRequestActionModalEnum.Cancel)">
        Cancel Booking
      </button>
    }
    @if (
      !isEditMode() &&
      bookingDetails.bookingDetails.status.value ===
        BookingStatusEnum.InProgress
    ) {
      <button
        rds-secondary-button
        *bshHasAccess="{
          role,
          permissions: [Permission.CAN_REJECT_ROOMBOOKINGS],
        }"
        size="m"
        (click)="openModal(BookingRequestActionModalEnum.Reject)">
        Reject
      </button>
      <button
        rds-primary-button
        *bshHasAccess="{
          role,
          permissions: [Permission.CAN_APPROVE_ROOMBOOKINGS],
        }"
        size="m"
        (click)="openModal(BookingRequestActionModalEnum.Confirm)">
        Approve
      </button>
    }
  </div>
}
